/**
 * @author：
 * @update：
 * @description：
 **/
import {worksDetail, fileEcho, worksSubMit} from '@/api/url'
import {transactionHttps} from '@/config/config'

export default {
    data() {
        return {
            fileEcho: fileEcho,
            transactionHttps: transactionHttps,
            storeDetail: '',//店铺详情
            goodsList: [],//商品列表
            worksContent: '',//作品的信息
            copyrightOwnerList: [],//著作权人信息
            authorList: [],//作者信息
            contractList: [],//合同
            fileList: [],//附件列表
            listState: '',//审核状态
            stateData:[],//审核列表
            auditRadio: true,//审核是否通过
            causeInput: '',//审核不通过原因
        };
    },
    // 自定义方法
    methods: {
        //作品详情
        worksData() {
            this.$ajax.get(worksDetail(this.$route.query.id), {id: this.$route.query.id}).then(res => {
                this.listState = res.data.state;
                this.stateData = res.data.audits;
                let data = res.data;
                this.worksContent = data;
                //店铺信息
                if (data.spus.length > 0) {
                    this.storeDetail = data.spus[0].store;
                    this.goodsList = data.spus;
                }
                //著作权人信息
                let ownersData = [];
                for (let i = 0; i < data.owners.length; i++) {
                    let obj = {};
                    obj.permanentId = data.owners[i].id;
                    obj.id = data.owners[i].id;
                    obj.copyrightId = data.owners[i].id;
                    obj.name = data.owners[i].name;
                    obj.type = data.owners[i].category;
                    obj.nationality = data.owners[i].nationality;
                    obj.province = data.owners[i].province;
                    obj.city = data.owners[i].city;
                    obj.certificatesType = data.owners[i].idType;
                    obj.certificatesNumber = data.owners[i].idNumber;
                    obj.signature = data.owners[i].signature;
                    obj.alias = data.owners[i].alias;
                    ownersData.push(obj)
                }
                this.copyrightOwnerList = ownersData;
                let authorsData = [];
                //作者信息
                for (let i = 0; i < data.authors.length; i++) {
                    let obj = {};
                    obj.permanentId = data.authors[i].id;
                    obj.id = data.authors[i].id;
                    obj.authorId = data.authors[i].id;
                    obj.name = data.authors[i].name;
                    obj.signature = data.authors[i].signature;
                    authorsData.push(obj)
                }
                this.authorList = authorsData;
                //合同
                if (data.transfer == true || data.permission == true) {
                    let contractsData = [];
                    for (let i = 0; i < data.contracts.length; i++) {
                        let obj = {};
                        obj.id = data.contracts[i].id;
                        obj.name = data.contracts[i].name;
                        obj.signer = data.contracts[i].signatories.join(',');
                        obj.date = data.contracts[i].effectiveDate;
                        obj.files = [];
                        let filename = [];
                        for (let j = 0; j < data.contracts[i].attachments.length; j++) {
                            let objs = data.contracts[i].attachments[j].file;
                            // objs.originName = data.contracts[i].attachments[j].file.filename;
                            objs.readableSize = data.contracts[i].attachments[j].file.readableSize;
                            objs.type = data.contracts[i].attachments[j].file.type;
                            objs.id = data.contracts[i].attachments[j].file.id;
                            objs.bigId = data.contracts[i].attachments[j].id;
                            obj.files.push(objs);
                            filename.push(data.contracts[i].attachments[j].file.filename);
                        }
                        obj.file = filename.join(',');
                        contractsData.push(obj)
                    }
                    this.contractList = contractsData;
                }
                //附件
                let filesData = [];
                for (let i = 0; i < data.attachments.length; i++) {
                    let obj = data.attachments[i].file;
                    obj.readableSize = data.attachments[i].file.readableSize;
                    obj.type = data.attachments[i].file.type;
                    // obj.originName = data.attachments[i].file.filename;
                    obj.bigId = data.attachments[i].id;
                    filesData.push(obj)
                }
                this.fileList = filesData;
            }, err => {
                console.log(err);
                this.$message({
                    showClose: true,
                    message: err.data,
                    type: 'error',
                    center: true,
                    duration: 3000
                })
            })
        },
        //打开商品详情
        opGoodsDetails(id) {
            window.open(transactionHttps + "#/details?id=" + id )
        },
        //取消
        cancelBtn() {
            this.$router.push({path: '/works'});
        },
        //提交
        confirmBtn() {
            if(this.auditRadio==false){
                if(this.causeInput==''){
                    this.$message({
                        showClose: true,
                        message: '请输入审核不通过原因',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                    return false
                }
            }
            this.$ajax.post(worksSubMit(this.$route.query.id), {
                pass: this.auditRadio,
                opinion: this.causeInput,
                workId: this.$route.query.id,
            }).then(res => {
                this.$message({
                    message: '审核成功',
                    type: 'success'
                });
                this.$router.push({path: '/works'});
            })
        },
        //审核员
        returnUserInfo(userInfo){
            let name = '--';
            if(userInfo.type=="ENTERPRISE"){
                name = userInfo.legalPerson;
            }else{
                if(userInfo.state=="CERTIFIED"){
                    name = userInfo.realName
                }else{
                    name = userInfo.nickname
                }
            }
            return name
        },
    },
    // 数据观察监听
    watch: {},
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {
        this.worksData()
    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
